/* kk-mega-menu.js — desktop mega panel v2 enhancements (KK 2026-09-02). Progressive: the
   panel opens/closes with pure CSS (:hover / :focus-within, section-header.css), this only adds
     1. Esc closes the open panel — the hovered item gets .is-dismissed (panel forced closed by
        kk-mega-menu.css) until the pointer leaves it; keyboard focus returns to the trigger
        so the panel does not immediately re-open via :focus-within.
     2. Theme editor: selecting a "mega_banner" block opens the panel it lives in (.is-open),
        because the editor cannot hover the menu for you.
   Nothing here runs below 1100px in practice (the nav row is display:none). */
(function () {
  'use strict';
  var items = Array.prototype.slice.call(document.querySelectorAll('.s-header__nav-item--mega'));
  if (!items.length) return;

  function itemOf(el) {
    return el && typeof el.closest === 'function' ? el.closest('.s-header__nav-item--mega') : null;
  }
  function isOpen(li) {
    try {
      return li.matches(':hover') || li.matches(':focus-within') || li.classList.contains('is-open');
    } catch (e) { return li.classList.contains('is-open'); }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var closedAny = false;
    items.forEach(function (li) {
      if (!isOpen(li)) return;
      li.classList.add('is-dismissed');
      li.classList.remove('is-open');
      closedAny = true;
    });
    if (!closedAny) return;
    var active = document.activeElement;
    var li = itemOf(active);
    if (li) {
      var trigger = li.querySelector('.s-header__nav-link');
      if (trigger && trigger !== active) trigger.focus();
      else if (active && active.blur) active.blur();
    }
  });

  items.forEach(function (li) {
    var clear = function () { li.classList.remove('is-dismissed'); };
    li.addEventListener('mouseleave', clear);
    li.addEventListener('mouseenter', clear);
    // Tabbing away re-arms the item; tabbing back in re-opens via :focus-within.
    // If the pointer is still inside (Esc while hovering AND focused), stay dismissed —
    // mouseleave re-arms it instead, otherwise :hover would re-open the panel at once.
    li.addEventListener('focusout', function (e) {
      if (li.contains(e.relatedTarget)) return;
      var hovered = false;
      try { hovered = li.matches(':hover'); } catch (err) { hovered = false; }
      if (!hovered) clear();
    });
  });

  // Theme editor block preview.
  document.addEventListener('shopify:block:select', function (e) {
    var li = itemOf(e.target);
    if (!li) return;
    items.forEach(function (x) { x.classList.remove('is-open'); });
    li.classList.add('is-open');
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var li = itemOf(e.target);
    if (li) li.classList.remove('is-open');
  });
})();

/* 2026-09-17: the (i) inside a menu badge sits in a link - a tap/click toggles the tooltip instead of navigating */
(function () {
  function onI(e) {
    var i = e.target && e.target.closest ? e.target.closest('.kk-mm-i') : null; if (!i) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault(); e.stopPropagation();
    var b = i.closest('.kk-mm-tip'); if (!b) return;
    var open = b.classList.contains('is-open');
    document.querySelectorAll('.kk-mm-tip.is-open').forEach(function (n) { n.classList.remove('is-open'); });
    if (!open) b.classList.add('is-open');
  }
  document.addEventListener('click', onI, true);
  document.addEventListener('keydown', onI, true);
  document.addEventListener('click', function (e) { if (!(e.target.closest && e.target.closest('.kk-mm-tip'))) document.querySelectorAll('.kk-mm-tip.is-open').forEach(function (n) { n.classList.remove('is-open'); }); });
})();
